import { render, staticRenderFns } from "./dui-dropdown.vue?vue&type=template&id=cb0794ba&"
import script from "./dui-dropdown.vue?vue&type=script&lang=js&"
export * from "./dui-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./dui-dropdown.vue?vue&type=style&index=0&id=cb0794ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports